// extracted by mini-css-extract-plugin
export default {"cls1":"JTuLUC0kKsfdeRuYLl9l","cls2":"ai4P7IRYyhZiNWE2RcSP JTuLUC0kKsfdeRuYLl9l"};